import { User, UserLangEnum, UserSetting, UserSettingEnum } from "@/types/user";
import { getStorage } from "@/utils/storage";
import { createContext } from "react";

export type UserSettings = Array<UserSetting>;

export type UserSettingContextType = [
  [User | null, (params: User | null) => void],
  [UserSettings, (params: UserSettings) => void]
];

export const settings: UserSettings = [
  { type: UserSettingEnum.LANG, value: getStorage("locale") ?? UserLangEnum.EN },
  { type: UserSettingEnum.THEME, value: getStorage("theme") ?? "#7a294f" },
];

export const UserContext = createContext<UserSettingContextType>([
  [null, () => {}],
  [settings, () => {}],
]);
